// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/order-claims.less
// module id = 3756
// module chunks = 0